<template>
    <div>
        <b-sidebar
            v-model="open"
            title="Detalhes da Turma"
            backdrop-variant="dark"
            width="390px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="group">
                <dl>
                    <dt>
                        Código
                        <i class="fas fa-sm fa-info-circle" v-b-tooltip.hover title="Código usado para os alunos se cadastrarem na turma"></i>
                    </dt>
                    <dd>
                        {{ group.code }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Nome
                    </dt>
                    <dd>
                        {{ group.name }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Nº de Alunos
                    </dt>
                    <dd>
                        {{ group.students_count }}
                    </dd>
                </dl>
                <dl v-if="externalLinkGroup">
                    <dt>
                        Link Externo
                    </dt>
                    <dd>
                        <a v-if="group.external_link" :href="group.external_link" target="_blank" class="text-primary">
                            <i class="fas fa-external-link-alt mr-1"></i>
                            {{ group.external_link | truncate(35) }}
                        </a>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl v-if="telegramByGroup">
                    <dt>
                        Link Telegram
                    </dt>
                    <dd>
                        <a v-if="group.telegram_number" :href="group.telegram_number" target="_blank" class="text-primary">
                            <i class="fas fa-external-link-alt mr-1"></i>
                            {{ group.telegram_number | truncate(35) }}
                        </a>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl v-if="telegram">
                    <dt>
                        Link do Telegram
                    </dt>
                    <dd>
                        <span v-if="group.telegram_enabled" class="text-success">
                            <i class="fas fa-sm fa-circle text-success mr-1"></i>
                            Ativo
                            </span>
                        <span v-else class="text-danger">
                            <i class="fas fa-sm fa-circle mr-1 text-danger"></i>
                            Inativo
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Matrículas Abertas ?
                    </dt>
                    <dd>
                        <span v-if="group.open" v-b-tooltip.hover title="Os alunos poderão se matricular nessa turma usando apenas o código da turma">
                            <i class="fas fa-sm fa-circle text-success mr-1"></i>
                            Abertas
                        </span>
                        <span v-else v-b-tooltip.hover title="Os alunos não conseguirão se matricular nessa turma no momento">
                            <i class="fas fa-sm fa-circle mr-1 text-danger"></i>
                            Fechadas
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Alunos poderão enviar redações ?
                    </dt>
                    <dd>
                        <span v-if="group.send_essay" v-b-tooltip.hover title="Os alunos poderão enviar a redação pela plataforma">
                            <i class="fas fa-sm fa-circle text-success mr-1"></i>
                            Sim
                        </span>
                        <span v-else v-b-tooltip.hover title="Os alunos não conseguirão enviar redações">
                            <i class="fas fa-sm fa-circle mr-1 text-danger"></i>
                            Não
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Vídeo Painel Inicial
                    </dt>
                    <dd>
                        <a v-if="group.tutorial" :href="group.tutorial" target="_blank" class="text-primary">
                            <i class="fas fa-external-link-alt mr-1"></i>
                            {{ group.tutorial | truncate(35) }}
                        </a>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl v-if="integrationHotmart">
                    <dt>
                        Integração com o Hotmart
                    </dt>
                    <dd>
                        {{ group.course_hotmart ? group.course_hotmart : '---' }}
                    </dd>
                </dl>
                <dl v-if="integrationEduzz">
                    <dt>
                        Integração com a Eduzz
                    </dt>
                    <dd>
                        {{ group.content_eduzz_id ? group.content_eduzz_id : '---' }}
                    </dd>
                </dl>

                <dl v-if="integrationBraip">
                    <dt>
                        Integração com a Braip
                    </dt>
                    <dd>
                        {{ group.course_braip_id ? group.course_braip_id : '---' }}
                    </dd>
                </dl>
                <dl v-if="integrationKiwify">
                    <dt>
                        Integração com o KiwiFy
                    </dt>
                    <dd>
                        {{ group.course_kiwify_id ? group.course_kiwify_id : '---' }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Mensagem na Tela Inicial dos Alunos
                    </dt>
                    <dd>
                        {{ group.message ? group.message : '---' }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Criado
                    </dt>
                    <dd>
                        {{ group.created_at | moment('from', 'now') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Última Alteração
                    </dt>
                    <dd>
                        {{ group.updated_at | moment('from', 'now') }}
                    </dd>
                </dl>
            </div>

            <template #footer v-if="group">
                <div class="d-flex bg-light text-dark align-items-center border-top px-3 py-2">

                    <div class="mr-auto">

                        <a href="#" class="mr-3" v-b-tooltip.hover title="Editar Turma" @click="editGroup">
                            <i class="fas fa-pencil-alt mr-1"></i> Editar
                        </a>

                        <a href="#" class=" text-danger" v-b-tooltip.hover title="Excluir Turma" @click="destroyGroup">
                            <i class="fas fa-trash-alt mr-1"></i> Excluir
                        </a>

                    </div>

                </div>
            </template>
        </b-sidebar>

        <!-- Edit -->
        <edit :endpoint="endpointUpdate" :external-link-group="externalLinkGroup" :telegram-by-group="telegramByGroup" :telegram="telegram" :integration-hotmart="integrationHotmart" :integration-eduzz="integrationEduzz" :integration-braip="integrationBraip" :integration-kiwify="integrationKiwify" :payment-stripe="paymentStripe" @updated="load"></edit>

        <!-- Destroy -->
        <destroy :endpoint="endpointDestroy" @destroyed="load"></destroy>

    </div>
</template>

<script>
import Edit from "./Edit";
import Destroy from "./Destroy";
import Invitation from "./Invitation";

export default {
    components: {
        Edit,
        Destroy,
    },
    props: ['endpointUpdate', 'endpointDestroy', 'externalLinkGroup', 'telegramByGroup', 'telegram', 'integrationHotmart', 'integrationEduzz', 'integrationBraip', 'integrationKiwify', 'paymentStripe'],
    data() {
        return {
            open: false,
            group: null
        }
    },
    created() {
        this.$root.$on('groupsShowDetail', (group) => {
            this.group = group
            this.open = true
        })
    },
    methods: {
        load() {
            this.$emit('load')
            this.open = false
        },

        editGroup() {
            this.$root.$emit('editGroup', this.group)
        },

        destroyGroup() {
            this.$root.$emit('destroyGroup', this.group)
        },

    }
}
</script>

<style scoped>

</style>
